import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const LoginContainer = styled(Box)(() => ({
  transform: "translate(-50%, -50%)",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  borderRadius: "16px",
  position: "absolute",
  left: "50%",
  backgroundColor: "#fff",
  height: "331px",
  width: "437px",
  alignItems: "center",
  gap: "36px",
}));
